import { render, staticRenderFns } from "./PortalLinksTab.vue?vue&type=template&id=885af9a0&scoped=true"
import script from "./PortalLinksTab.vue?vue&type=script&lang=ts"
export * from "./PortalLinksTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885af9a0",
  null
  
)

export default component.exports